document.addEventListener("DOMContentLoaded", function () {
    // Video controls
    const video = document.querySelector("video");
    const button = document.querySelector(".btn-video");
    const buttonImg = document.querySelector(".btn-video img");

    if (button && video && buttonImg) {
        button.addEventListener("click", function () {
            if (video.paused) {
                video.play();
                buttonImg.src = "imgs/icons/pause.png";
            } else {
                video.pause();
                buttonImg.src = "imgs/icons/play.png";
            }
        });
    }

    // Envolver tablas en páginas legales con scroll wrapper
    const legalPages = document.querySelectorAll(
        ".page-copyright, .page-legal_notice, .page-cookies, .page-system_information, .page-data_protection_policy"
    );

    legalPages.forEach((page) => {
        const tables = page.querySelectorAll("table");

        tables.forEach((table) => {
            if (!table.closest(".table-scroll-wrapper")) {
                const wrapper = document.createElement("div");
                wrapper.className = "table-scroll-wrapper";
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    });
});

Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

$(document).ready(function () {
    const $slides = $("#customCarousel .carousel-slide");
    let currentSlide = 0;
    const totalSlides = $slides.length;
    let autoplayInterval;
    let isAnimating = false;

    function initializeCarousel() {
        $slides.removeClass("active left right exiting");
        $slides.eq(currentSlide).addClass("active");
        updateSideSlides();
    }

    function updateSideSlides() {
        const nextIndex = (currentSlide + 1) % totalSlides;
        const prevIndex = (currentSlide - 1 + totalSlides) % totalSlides;

        $slides.removeClass("left right");
        $slides.eq(nextIndex).addClass("right");
        $slides.eq(prevIndex).addClass("left");
    }

    function showSlide(index, direction) {
        if (isAnimating || currentSlide === index) return;
        isAnimating = true;

        const $current = $slides.eq(currentSlide);
        const $next = $slides.eq(index);

        // Set up exiting animation
        $current
            .removeClass("active")
            .addClass("exiting")
            .css(
                "transform",
                direction === "next" ? "translateX(-100%)" : "translateX(100%)"
            );

        // Set up entering animation
        $next
            .css(
                "transform",
                direction === "next" ? "translateX(100%)" : "translateX(-100%)"
            )
            .css("transition", "none")
            .addClass("active")
            .offset(); // Force reflow

        // Trigger animations
        setTimeout(() => {
            $next.css({
                transform: "translateX(0)",
                transition: "all 0.6s ease-in-out",
            });

            $current.one("transitionend", function () {
                $(this).removeClass("exiting");
                isAnimating = false;
            });

            currentSlide = index;
            updateSideSlides();
        }, 10);

        resetAutoplay();
    }

    function resetAutoplay() {
        clearInterval(autoplayInterval);
        startAutoplay();
    }

    function startAutoplay() {
        autoplayInterval = setInterval(function () {
            if (!isAnimating) {
                showSlide((currentSlide + 1) % totalSlides, "next");
            }
        }, 5000);
    }

    if (totalSlides > 1) {
        initializeCarousel();
        startAutoplay();
        $("#carouselNext").on("click", function () {
            showSlide((currentSlide + 1) % totalSlides, "next");
        });
        $("#carouselPrev").on("click", function () {
            showSlide((currentSlide - 1 + totalSlides) % totalSlides, "prev");
        });
    } else {
        $("#carouselNext").hide();
        $("#carouselPrev").hide();
    }
});

// Features Carousel
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-carousel]').forEach(function(grid) {
        if (grid.dataset.carouselInitialized) return;
        grid.dataset.carouselInitialized = 'true';

        var items = Array.from(grid.querySelectorAll('.feature-item'));
        var itemsPerPage = parseInt(grid.dataset.itemsPerPage, 10) || 1;
        var totalPages = Math.ceil(items.length / itemsPerPage);
        var currentPage = 0;
        var carouselId = grid.dataset.carouselId;

        var prevBtn = document.querySelector('[data-carousel-prev="' + carouselId + '"]');
        var nextBtn = document.querySelector('[data-carousel-next="' + carouselId + '"]');

        function showPage(page) {
            items.forEach(function(item, index) {
                var itemPage = Math.floor(index / itemsPerPage);
                if (itemPage === page) {
                    item.classList.add('is-active');
                } else {
                    item.classList.remove('is-active');
                }
            });
        }

        function go(step) {
            currentPage = (currentPage + step + totalPages) % totalPages;
            showPage(currentPage);
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', function() { go(-1); });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', function() { go(1); });
        }

        showPage(0);

        if (totalPages > 1) {
            setTimeout(function() {
                var height = grid.offsetHeight;
                if (height > 0) {
                    grid.style.minHeight = height + 'px';
                }
            }, 50);
        }
    });
});
